<template>

  <div :class="{card:true, 'p-2':true, 'bg-group': parent, 'pt-4': true, 'pb-4': true, 'mt-3':true}">
      <div class="row">
        <div class="col-xs-12 col-md-3">
          <div class="text-center">
            <img v-if="company.logoPath" class="cursor-pointer hover-opacity" @click="$emit('logoClicked', company);" :src="company.logoPath" :alt="company.tradeTitle" height="70">
            <span v-else @click="$emit('logoClicked', company);" class="icomoon-office text-muted cursor-pointer hover-opacity" style="font-size:60px;"></span>
          </div>
        </div>
        <div class="col-xs-12 col-md-3">
          <div class="text-center text-md-left">
            <div>
              <span>{{ company.tradeTitle }}</span>
            </div>
            <div v-if="parent">member of {{ parent.tradeTitle }}</div>
          </div>
        </div>
        <div class="col-xs-12 col-md-3">
          <div class="text-center">
            <div v-if="isEditable"><a href="javascript:void(0);" @click="$emit('editCompanyClicked', company);">edit company</a></div>
            <div v-else><span class="text-muted cursor-forbidden">edit company</span></div>
            <div v-if="isDeletable"><a href="javascript:void(0);" @click="$emit('deleteCompanyClicked', company);">delete company</a></div>
            <div v-else><span class="text-muted cursor-forbidden">delete company</span></div>
            <div v-if="canEditCustomTopics"><a href="javascript:void(0);" @click="$emit('customTopicsClicked', company);">custom topics and criteria</a></div>
            <div v-else><span class="text-muted cursor-forbidden">custom topics and criteria</span></div>
          </div>
        </div>
        <div class="col-xs-12 col-md-3">
          <div class="text-center">
            <div>
              <div v-if="company.latestCase">
                <div style="font-size: 25px;">
                  <router-link :to="{path: '/case/' + company.latestCase.id}">{{ company.latestCase.year }}&nbsp;<span style="font-size: 20px;" class="ti-pencil-alt"></span></router-link>
                </div>
              </div>
              <div v-else class="text-muted">no ESG data</div>
            </div>
            <div v-if="canAddCase"><button class="btn btn-sm btn-neutral" @click="$emit('addCaseClicked', company);">+ add year</button></div>
            <div v-else><button class="btn btn-sm btn-neutral cursor-forbidden" disabled>+ add year</button></div>
          </div>
        </div>
      </div>
      <div class="row" v-if="company.childrenCompanyDtos.length">
        <div class="col-12">
          <company-card
            class="mt-2"
            v-for="(child, index) in company.childrenCompanyDtos"
            :key="index"
            :company="child"
            :parent="company"
            :is-editable="isEditable"
            :is-deletable="isDeletable"
            :can-add-case="canAddCase"
            :can-edit-custom-topics="canEditCustomTopics"
            @editCompanyClicked="emitEditCompanyClicked"
            @deleteCompanyClicked="emitDeleteCompanyClicked"
            @customTopicsClicked="emitCustomTopicsClicked"
            @addCaseClicked="emitAddCaseClicked"
            @logoClicked="emitLogoClicked"
          ></company-card>
        </div>
      </div>
  </div>

</template>
<script>
export default {
  name: "company-card",
  props: {
    company: Object,
    parent: Object,
    isEditable: Boolean,
    isDeletable: Boolean,
    canAddCase: Boolean,
    canEditCustomTopics: Boolean,
  },
  data () {
    return {
      
    };
  },
  computed: {
  },
  methods: {
    emitEditCompanyClicked (item) {
      this.$emit('editCompanyClicked', item);
    },
    emitDeleteCompanyClicked (item) {
      this.$emit('deleteCompanyClicked', item);
    },
    emitAddCaseClicked (item) {
      this.$emit('addCaseClicked', item);
    },
    emitLogoClicked (item) {
      this.$emit('logoClicked', item);
    },
    emitCustomTopicsClicked (item) {
      this.$emit('customTopicsClicked', item);
    },
  }
};
</script>
<style scoped>
.bg-group {
  background-color: #ffffff;
}
.cursor-forbidden {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.hover-opacity:hover {
  opacity: 0.8;
}
.btn-neutral {
  border-radius: 0px;
  padding-right: 30px;
  padding-left: 30px;
  border-radius: none;
}        
.btn-neutral:hover {
  background-color: white;   
  color: #717171;
  border: 2px solid black;
}
a {
  text-decoration: underline !important;
  color: #898989 !important;
}
a:hover {
  color: #aaa9a9;
}
</style>
